import React from "react"
import construction from '../images/under_construction.svg'


function ComingSoon (){
    return(
        <div className="flex flex-col justify-center items-center py-16 px-7 md:px-0">
            <img className="md:w-[1000px]" src={construction} alt="Construction_image" />

            <p className="font-alibaba uppercase text-[25px] md:text-[50px] text-center mt-7">Under Construction</p>
            <hr className="text-yellow w-[30%] md:w-[10%] border-t-4" />

            <p className="font-noto text-[15px] md:text-[25px] text-center mt-7">This page in our site is being developed. Will be brought up live soon!</p>
            <p className="font-noto text-[15px] md:text-[25px] text-center mt-7">Please visit back sometime later.</p>

        </div>
    )
}

export default ComingSoon